import React, { useState } from "react";
import "../assets/css/responsive.css";
import "../assets/css/style.css";
import "../assets/css/hamburger.css";

import PolitiqueConf from "../components/politique/politique";

const Politique = () => {
  return (
    <div className="main">
      <PolitiqueConf />
    </div>
  );
};

export default Politique;
